import { gql } from '@apollo/client'

export const GET_BUSINESS_CUSTOMER = gql`
  query GetBusinessCustomer($input: BusinessCustomerInput!) {
    businessCustomer(input: $input) {
      id
      type
      qrCode
      isEnabled
      hasHomePickupRoute
      kreditsSettings {
        amount
        category
      }
      businessClient {
        id
        name
        verticals
        isKreditEnabled
      }
      businessSite {
        id
        name
      }
      userAccount {
        id
        firstName
        lastName
        email
        phoneNumber {
          number
          countryCode
        }
      }
      place {
        address {
          line1
          zipCode
        }
        parent {
          id
          name
        }
      }
    }
  }
`

export const GET_BUSINESS_CUSTOMER_SUGGESTIONS = gql`
  query GetBusinessCustomerSuggestions(
    $input: BusinessCustomerSuggestionsInput!
    $sorting: SortingV2
    $pagination: PaginationV2
  ) {
    businessCustomerSuggestions(input: $input, sorting: $sorting, pagination: $pagination) {
      total
      items {
        id
        name
      }
    }
  }
`

export const GET_BUSINESS_CUSTOMERS_LIST = gql`
  query GetBusinessCustomers($input: BusinessCustomersInput!, $pagination: Pagination) {
    businessCustomers(input: $input, pagination: $pagination) {
      total
      items {
        id
        type
        isEnabled
        qrCode
        kreditsSettings {
          amount
          category
        }
        businessClient {
          id
          name
          isKreditEnabled
          isActive
        }
        businessSite {
          id
          name
        }
        userAccount {
          id
          firstName
          lastName
          email
          phoneNumber {
            number
            countryCode
          }
        }
        place {
          id
          parent {
            id
          }
          address {
            line1
            zipCode
          }
        }
      }
    }
  }
`

export const VALIDATE_BUSINESS_CUSTOMER_CSV = gql`
  mutation ValidateCustomerCSV($input: ValidateBusinessCustomersCSVInput!) {
    validateBusinessCustomersCSV(input: $input)
  }
`

export const GET_KAM_USER = gql`
  query GetKamUser($userId: ID!) {
    user(input: { id: $userId }) {
      id
      firstName
      lastName
      username
    }
  }
`
